module.exports = __webpack_public_path__ + "images/application/icon-server-type-9d2116ee.svg";